// extracted by mini-css-extract-plugin
module.exports = {"dot":"_6cb375b","spinner":"_bade356","ellipsis":"_b04456e","odds":"_1f4d6b9"};